<div class="{uiClasses} or" part="or">
  <div class="shape"><slot>or</slot></div>
</div>
